import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyAgreements } from '@/features/participant/agreements'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-agreements/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyAgreements,
})
